import React from 'react';

class Syds extends React.Component {
  render() {
    return (
      <div className="theme-syds">
        <div className="row content">
          <div className="keywords">
            <p className="content-title"><span>k</span>eywords</p>
            <div className="content-article">
              <div className="keywords__row"><p className="keywords__label">Position</p><p className="keywords__value">Full-stack Engineer</p></div>
              <div className="keywords__row"><p className="keywords__label">Skills</p><p className="keywords__value">ASP.NET · jQuery · MSSQL · IIS</p></div>
              <div className="keywords__row"><p className="keywords__label">Focus</p><p className="keywords__value">MES · Real-time Monitoring · Query Optimization · Smart Factory</p></div>
            </div>
          </div>
          <p className="content-title"><span>a</span>bstract</p>
          <div className="content-article content-article-paragraphs">
            <p>
              Samyang is one of the top 200th companies in South Korea. 
              It has three main industries - chemical, food, and research.
            </p>
            <p>
              I worked as a programmer in the System Management Department, 
              especially on Manufacturing Execution Systems, associated with food 
              and chemical factories.
            </p>
          </div>
          <p className="content-title"><span>p</span>rojects</p>
          <div className="content-article content-article-list">
            <p>• Real-time production polymerization monitoring</p>
            <p>• Smart factory 2.0 total solution</p>
          </div>
          <p className="content-title"><span>m</span>aintanance</p>
          <div className="content-article">
            <p>• Sugar, ion exchange resin manufacturing factory, Ulsan.</p>
            <p>• Organic material manufacturing for information electronices factory, Sejong.</p>
          </div>
          <p className="content-title"><span>e</span>xperience</p>
          <div className="content-article content-article-list content-final">
            <p>• Developed a real-time monitoring system for a chemical polymerization process using ASP.NET</p>
            <p>• Developed factory software for the MES (Manufacturing Execution System) department using ASP.NET, IIS, and jQuery</p>
            <p>• Optimized MSSQL queries</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Syds;
